import React, { ReactNode } from "react";

type Props = {
  title: string;
  children: ReactNode;
};

/**
 * Renders one menu section.
 */
export const MenuSection = ({ title, children }: Props) => {
  return (
    <div className="section">
      <div className="title">{title}</div>
      <div className="items">{children}</div>
    </div>
  );
};
